import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import { Stack, createStack } from '@famly/mf_layout_stack';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { useCustomWhitelabelColor } from 'signin-app/components/hooks/use-custom-whitelabel-color';
const TimeBoxContainer = styled(createStack({
    alignItems: 'center',
    justifyContent: 'center',
    px: '16px',
    py: '24px',
    width: '104px',
    maxHeight: { base: '64px', tabletPortrait: '80px' },
    minHeight: { base: '64px', tabletPortrait: '80px' },
    borderRadius: '16px',
})).withConfig({
    shouldForwardProp: prop => prop !== 'selected' && prop !== 'customBorderColor' && prop !== 'customBackgroundColor',
}) `
    box-sizing: border-box;
    border: 2px solid ${props => (props.selected ? props.customBorderColor : props.theme.mf.colorPalette.n200)};
    background-color: ${props => (props.selected ? props.customBackgroundColor : 'transparent')};
    cursor: pointer;
    color: ${props => props.theme.mf.colorPalette.n400};
`;
const TimeBox = ({ value, selected, displayValue, className, subText, dataE2eTimeHour, size = 'regular', handleOnClick, }) => {
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const p300 = useCustomWhitelabelColor('p300');
    const p200 = useCustomWhitelabelColor('p200');
    const selectTime = React.useCallback(() => {
        handleOnClick(value);
    }, [handleOnClick, value]);
    const timeValue = displayValue === undefined ? value : displayValue;
    return (_jsx(TimeBoxContainer, { onClick: selectTime, className: className, "data-e2e-class": dataE2eTimeHour, customBorderColor: p300, customBackgroundColor: p200, selected: selected, ...(size === 'compact'
            ? {
                width: 'auto',
                minWidth: '72px',
                minHeight: '56px',
                maxHeight: '56px',
                px: '12px',
                py: '0',
                flexShrink: 0,
            }
            : {}), children: _jsxs(Stack, { flexDirection: "column", justifyContent: "center", alignItems: "center", children: [_jsx(Text, { variant: isTabletPortraitAndLarger && size === 'regular' ? 'h4' : 'h6', color: "n400", children: timeValue }), _jsx(Box, { children: subText })] }) }));
};
export default TimeBox;
